import { AdZone, AdZoneCard } from "@/types/adZones";

export const FOOTER_GUIDE_CARD_COUNT = 4;

/** Titre fixe de la section (indépendant des titres des cartes) */
export const FOOTER_GUIDES_SECTION_TITLE = "Guides Pratiques pour Entrepreneur.es";

export const createEmptyFooterCards = (count = FOOTER_GUIDE_CARD_COUNT): AdZoneCard[] =>
  Array.from({ length: count }, () => ({
    image_url: null,
    title: "",
    cta_label: "",
    cta_url: "",
  }));

export const normalizeFooterCards = (
  cards: AdZoneCard[] | null | undefined,
  legacyZone?: Pick<AdZone, "title" | "image_url" | "cta_label" | "cta_url">
): AdZoneCard[] => {
  if (cards && cards.length > 0) {
    const normalized = cards.map((card) => ({
      image_url: card.image_url?.trim() || null,
      title: card.title?.trim() ?? "",
      cta_label: card.cta_label?.trim() ?? "",
      cta_url: card.cta_url?.trim() ?? "",
    }));

    while (normalized.length < FOOTER_GUIDE_CARD_COUNT) {
      normalized.push({
        image_url: null,
        title: "",
        cta_label: "",
        cta_url: "",
      });
    }

    return normalized.slice(0, FOOTER_GUIDE_CARD_COUNT);
  }

  if (legacyZone) {
    const first: AdZoneCard = {
      image_url: legacyZone.image_url,
      title: "",
      cta_label: legacyZone.cta_label ?? "",
      cta_url: legacyZone.cta_url ?? "",
    };

    return [first, ...createEmptyFooterCards(FOOTER_GUIDE_CARD_COUNT - 1)];
  }

  return createEmptyFooterCards();
};

export const isFooterCardFilled = (card: AdZoneCard): boolean =>
  !!(card.title.trim() || card.image_url || (card.cta_label.trim() && card.cta_url.trim()));

export const getActiveFooterCards = (zone: AdZone): AdZoneCard[] =>
  normalizeFooterCards(zone.cards, zone).filter(isFooterCardFilled);
